
import React from "react";
import { Label } from "@/components/ui/label";
import { Input } from "@/components/ui/input";
import { ImagePreview } from "./ImagePreview";

interface ImageUploadProps {
  imagePreview: string | null;
  onImageChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onImageError: () => void;
}

export function ImageUpload({ imagePreview, onImageChange, onImageError }: ImageUploadProps) {
  return (
    <div className="space-y-2">
      <Label htmlFor="image">Εικόνα</Label>
      <Input 
        id="image" 
        name="image" 
        type="file" 
        onChange={onImageChange} 
        accept="image/*" 
      />
      <ImagePreview imagePreview={imagePreview} onError={onImageError} />
    </div>
  );
}
